import { render, staticRenderFns } from "./BackupIndex.vue?vue&type=template&id=17e41a6f"
import script from "./BackupIndex.vue?vue&type=script&lang=js"
export * from "./BackupIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports